import React from 'react'
import intl from 'react-intl-universal'
import { LOCALE } from '@foxrenderfarm/internals'
import { LightDropDownSection, LightNavDropDownWrapper } from '../../atoms'
import { AboutCompanyIcon, AboutGlobalResellersIcon, AboutPartnersIcon } from '../../svg'
import { LightNavDropDownPanel, MainLink, Trigger, getLocalAppOrigin, isPathActive } from './common'

interface AboutLightDropDownProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
}

export const AboutLightDropDown = ({
  currentLocale,
  currentPathname,
  origin,
}: AboutLightDropDownProps) => {
  const useGatsbyLink = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)

  const items = [
    {
      key: 'company',
      name: intl.get('index.header.about.company'),
      to: '/about.html',
      Icon: AboutCompanyIcon,
    },
    {
      key: 'global-resellers',
      name: intl.get('index.header.about.global.resellers'),
      to: '/global-partner.html',
      Icon: AboutGlobalResellersIcon,
    },
    {
      key: 'partners',
      name: intl.get('index.header.about.partners'),
      to: '/partner.html',
      Icon: AboutPartnersIcon,
    },
  ]

  const active = items.some((item) => isPathActive(currentPathname, item.to, currentLocale))

  return (
    <LightNavDropDownWrapper $isActive={active} $panelMinWidth={260}>
      <Trigger>{intl.get('index.header.about')}</Trigger>
      <LightNavDropDownPanel panelTitle={intl.get('index.header.about')}>
        <LightDropDownSection>
          {items.map((item) => {
            const Icon = item.Icon
            return (
              <MainLink
                key={item.key}
                to={item.to}
                href={`${mainOrigin}${item.to}`}
                useGatsbyLink={useGatsbyLink}
                locale={currentLocale}
                $highlight={isPathActive(currentPathname, item.to, currentLocale)}
              >
                {Icon && <Icon style={{ marginRight: 8 }} />}
                {item.name}
              </MainLink>
            )
          })}
        </LightDropDownSection>
      </LightNavDropDownPanel>
    </LightNavDropDownWrapper>
  )
}
